import { render, staticRenderFns } from "./ProfileRacerTab.vue?vue&type=template&id=f4f545da"
import script from "./ProfileRacerTab.vue?vue&type=script&lang=js"
export * from "./ProfileRacerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports